var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM10.3581 7.38248C9.38546 7.78704 7.44153 8.62437 4.52633 9.89448C4.05295 10.0827 3.80497 10.2669 3.78239 10.447C3.74424 10.7513 4.12535 10.8711 4.64431 11.0343C4.71491 11.0565 4.78805 11.0795 4.86303 11.1039C5.37362 11.2699 6.06044 11.464 6.41749 11.4717C6.74137 11.4787 7.10286 11.3452 7.50195 11.0712C10.2257 9.23254 11.6317 8.30322 11.72 8.28318C11.7823 8.26905 11.8686 8.25128 11.9271 8.30325C11.9855 8.35522 11.9798 8.45364 11.9736 8.48005C11.9358 8.64099 10.4399 10.0318 9.66569 10.7515C9.42435 10.9759 9.25315 11.1351 9.21815 11.1714C9.13976 11.2528 9.05986 11.3299 8.98307 11.4039C8.50873 11.8612 8.15301 12.2041 9.00276 12.764C9.41111 13.0331 9.73788 13.2557 10.0639 13.4777C10.4199 13.7201 10.775 13.9619 11.2344 14.2631C11.3515 14.3398 11.4633 14.4195 11.5722 14.4971C11.9865 14.7925 12.3587 15.0579 12.8186 15.0156C13.0858 14.991 13.3618 14.7397 13.502 13.9903C13.8333 12.2193 14.4844 8.38209 14.6349 6.80086C14.6481 6.66232 14.6315 6.48502 14.6182 6.40719C14.6049 6.32936 14.5771 6.21847 14.4759 6.13638C14.3561 6.03916 14.1711 6.01866 14.0884 6.02011C13.7123 6.02674 13.1352 6.22739 10.3581 7.38248Z",
    fill: "#403E68"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.4d2eb1b0ed41b8e813e2baeb04e467db.svg";
export { ForwardRef as ReactComponent };